import React from 'react';
import PropTypes from 'prop-types';
import CardStamp from "../DashboardCard/CardStamp";
import CardTitle from "../DashboardCard/CardTitle";
import CardActions from "../DashboardCard/CardActions";
import CardContent from "../DashboardCard/CardContent";
import ActionButton from "../DashboardCard/ActionButton";
import DashboardCard from "../DashboardCard/index";
import FaqIcon from '@material-ui/icons/ContactSupport';
import AppRequest from "../../../common/models/AppRequest";
import { isRequestStateSuccess } from "../../../common/util/request";

const { GET_FAQS } = AppRequest;
const isLoading = reqState => !isRequestStateSuccess(reqState, GET_FAQS);

const createSubtitle = (requestState, count) =>
  isLoading(requestState) ? 'Loading...' : `${count} FAQ${count === 1 ? '' : 's'}`;

class FaqCard extends React.PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    onAddFaq: PropTypes.func,
    faqCount: PropTypes.number,
    requestState: PropTypes.object,
  };

  static defaultProps = {
    faqCount: 0,
    requestState: {},
  };

  static getDerivedStateFromProps(nextProps) {
    return { subtitle: createSubtitle(nextProps.requestState, nextProps.faqCount) }
  }

  state = {
    subtitle: ''
  };

  render() {
    const { subtitle } = this.state;
    const { onAddFaq, requestState, onClick } = this.props;

    return (
      <DashboardCard onClick={onClick}>
        <CardStamp backgroundColor="#B5AA18" color="white">
          <FaqIcon />
        </CardStamp>

        <CardContent>
          <CardTitle title="FAQ" subtitle={subtitle}/>
          <CardActions>
            <ActionButton
              label="FAQ"
              onClick={onAddFaq}
              disabled={isLoading(requestState)}
            />
          </CardActions>
        </CardContent>
      </DashboardCard>
    );
  }
}

export default FaqCard;